import * as Yup from 'yup';


export const requestToFormData = data => ({
  name: data.name,
  mac: data.accessPoint.macs.join('\n'),
});

export const formToRequestData = values => ({
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
  body: JSON.stringify({
    name: values.name,
    // accessPoint: {
    //   macs: values.mac.split('\n').filter(s => s !== ''),
    // },
  }),
});

export const baseUrl = `${process.env.REACT_APP_API_URL}/placement`;

export const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required(),
  // mac: Yup.string()
  //   .required()
  //   .test(
  //     'mac-format',
  //     'Formato erroneo',
  //     value =>
  //       value && value.split('\n').every(
  //         str => str === '' || /^([0-9a-f]{2}:){5}[0-9a-f]{2}$/i.test(str),
  //       ),
  //   ),
})


export const formsInputsData = [
  {
    id: 'name',
    title: 'PLACEMENT.PLACEMENT_NAME',
    type: 'text',
    iconName: 'name',
  },
  {
    id: 'mac',
    title: 'PLACEMENT.PLACEMENT_MAC',
    type: 'textarea',
    iconName: 'mac-address',
    disabled: true
  },
];

export const initialValues = {
  name: '',
  mac: '',
};
